import { Component, Input } from '@angular/core';
import { Language } from '@libraries/design-system';
import { parseAddress } from '@libraries/helpers';
import { Environment } from '@libraries/shared-env';
import { Store, select } from '@ngrx/store';
import { take } from 'rxjs/operators';
import {
  SubmitWaitlistProperty,
  SwitchPreferredLanguage,
  getIneligiblePropertyData,
  getPreferredLanguage,
  getQuestionsPrefill,
} from '../../state';
import { WaitlistProperty } from '../../state/models/not-eligible-data';

@Component({
  selector: 'congratulations-waitlist',
  templateUrl: './congratulations-waitlist.component.html',
  styleUrl: './congratulations-waitlist.component.scss',
  standalone: false,
})
export class CongratulationsWaitlistComponent {
  @Input() currentLanguage = '';
  @Input() showLanguageToggler = true;
  preferredLanguage$ = this.store.select(getPreferredLanguage);
  showWaitlistBtn = true;
  boundaryCode = '';
  constructor(private store: Store, public env: Environment) {}

  joinWaitlistClicked() {
    this.store.pipe(select(getIneligiblePropertyData)).subscribe((data) => {
      this.boundaryCode = data.boundaryCode;
    });
    this.store.pipe(select(getQuestionsPrefill), take(1)).subscribe((questionsData) => {
      const formatAddress = parseAddress(questionsData.baseQuestions.address);
      const ineligible_property: WaitlistProperty = {
        address: formatAddress.line_1,
        city: formatAddress.city,
        state: formatAddress.state,
        zip: formatAddress.zipcode,
        phone: questionsData.baseQuestions.phone,
        email: questionsData.baseQuestions.email,
        boundaryCode: this.boundaryCode,
        improvements: questionsData.improvements,
      };
      this.store.dispatch(SubmitWaitlistProperty({ payload: ineligible_property }));
    });
    this.showWaitlistBtn = false;
  }

  toggleLanguage(language: Language) {
    this.store.dispatch(
      SwitchPreferredLanguage({
        preferredLanguage: language,
      })
    );
  }
  homeBtnClick() {
    window.location.href = 'https://www.ygrene.com';
  }
}
